import { Box, Stack, Text, styled } from '@ltvco/refresh-lib/theme';
import { ErrorOutline } from '@mui/icons-material';
import { useEffect } from 'react';

interface ImageUploadErrorAlertProps {
  message: string;
  onClose: () => void;
  isLanding?: boolean;
}

interface ContainerProps {
  isLanding?: boolean;
}

const Container = styled(Box)<ContainerProps>(({ theme, isLanding }) => ({
  width: '98%',
  padding: theme.spacing(2, 2, 1, 2),
  margin: '0 auto',
  '@media (min-width: 1024px)': {
    maxWidth: '740px',
  },
  ...(isLanding && {
    width: '100%',
    maxWidth: '100%',
    [theme.breakpoints.up('md')]: {
      width: '60%',
    },
  }),
}));

const AlertBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
  padding: theme.spacing(1.5, 2),
  backgroundColor: theme.palette.background.paper,
  borderRadius: theme.spacing(2),
  border: `1px solid ${theme.palette.error.light}`,
}));

const IconContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 24,
  height: 24,
  borderRadius: '50%',
  backgroundColor: theme.palette.error.light,
  border: `1px solid ${theme.palette.error.main}`,
  flexShrink: 0,
}));

const StyledErrorIcon = styled(ErrorOutline)(({ theme }) => ({
  fontSize: 16,
  color: theme.palette.error.main,
}));

const TextStack = styled(Stack)(() => ({
  flex: 1,
}));

const TitleText = styled(Text)(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text.primary,
}));

const MessageText = styled(Text)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const ImageUploadErrorAlert = ({
  message,
  onClose,
  isLanding = false,
}: ImageUploadErrorAlertProps) => {
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);

    return () => {
      clearTimeout(timer);
    };
  }, [onClose]);

  return (
    <Container isLanding={isLanding}>
      <AlertBox>
        <IconContainer>
          <StyledErrorIcon />
        </IconContainer>
        <TextStack spacing={0.5}>
          <TitleText variant="body2">Image Upload failed</TitleText>
          <MessageText variant="body2">{message}</MessageText>
        </TextStack>
      </AlertBox>
    </Container>
  );
};
